export const ANONYMOUS = 'anonymous';
export const BACKEND_DISCONNECT_PROCESSING_DELAY_MS = 1500;
